<script lang="ts" setup>
import type { StaticPageListItemDetails } from '~/types/StaticPageList';

const route = useRoute();
const siteStore = useSiteStore();
const specialOffersStore = useSpecialOffersStore();
const specialOffer = ref<StaticPageListItemDetails | null>(null);

const params = route.params as { slug: string };
specialOffer.value = await specialOffersStore.getSpecialOffersItemBySlug(params.slug);

if (!specialOffer.value) {
  throw createError({ statusCode: 404, message: 'Страница не найдена' });
}

siteStore.currentPageBreadcrumb = specialOffer.value.title;

useHead({
  title: specialOffer.value.seoData.title,
  meta: [
    { name: 'description', content: specialOffer.value.seoData.description ?? specialOffer.value.annotation },
    { property: 'og:title', content: specialOffer.value.seoData.title },
    { property: 'og:description', content: specialOffer.value.seoData.description ?? specialOffer.value.annotation },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: route.fullPath },
    { property: 'og:site_name', content: 'Hellride.ru' },
    { property: 'og:locale', content: 'ru_RU' },
    { property: 'og:image', content: specialOffer.value.mainImage.url },
  ],
});
</script>

<template>
  <StaticPage
    v-if="specialOffer"
    :item="specialOffer"
  />
</template>
